/*
 * Copyright © 2023 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FcAccordionComponent} from './fc-accordion.component';
import {FcAccordionItemComponent} from './fc-accordion-item/fc-accordion-item.component';

/**
 * Fc Accordion module.
 */
@NgModule({
    declarations: [
        FcAccordionComponent,
        FcAccordionItemComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        FcAccordionComponent,
        FcAccordionItemComponent
    ]
})
export class FcAccordionModule {
}
